import { useInvalidateRepositoryQuery } from '@mews-commander/data-access';

export const useInvalidateUserProfile = () => {
    const invalidate = useInvalidateRepositoryQuery();

    return (userId: string) => {
        void invalidate('userProfiles', 'getAll');
        void invalidate('userProfiles', 'get', { userId });
    };
};
